import { useTheme } from 'styled-components';

import { RateCategories } from '../utils/savingsUtils';

import { StyledKeylineDiv } from './Styled';
import StyledTable from './Styled/StyledTable';
import TariffRateTableRow from './TariffRateTableRow';

const getRowContent = (key, theme) => {
  switch (key) {
    case RateCategories.DAY:
      return {
        heading: 'Day Rate',
        description: 'Average cost electricity.',
        color: theme.colors.dark,
        bgColor: theme.colors.white,
        borderColor: theme.colors.dark,
      };
    case RateCategories.CHEAP:
      return {
        heading: 'Cheap Rate',
        description: 'Charge the battery when the import rate is at its lowest.',
        color: theme.colors.white,
        bgColor: theme.colors.success,
        borderColor: theme.colors.success,
      };
    case RateCategories.PEAK:
      return {
        heading: 'Peak Rate',
        description: 'Consume power from the battery when the import rate is highest for biggest savings.',
        color: theme.colors.dark,
        bgColor: theme.colors.solarLight,
        borderColor: theme.colors.solarLight,
      };
    default:
      return null;
  }
};

const TariffRateTableSection = ({ keyLine, rates, columns, wrapperClass = '' }) => {
  const WrapperComponent = keyLine ? StyledKeylineDiv : 'div';
  const theme = useTheme();

  return (
    <>
      <WrapperComponent className={wrapperClass}>
        <StyledTable>
          <thead>
            <tr>
              <StyledTable.Th></StyledTable.Th>
              {columns.includes('import') && (
                <StyledTable.Th color={theme.colors.imported} width="28%">
                  Import
                  <br />
                  (p/kWh)
                </StyledTable.Th>
              )}
              {columns.includes('export') && (
                <StyledTable.Th color={theme.colors.exported} width="28%">
                  Export
                  <br />
                  (p/kWh)
                </StyledTable.Th>
              )}
            </tr>
          </thead>
          <tbody>
            {rates &&
              Object.values(RateCategories).map((category) => {
                const importRate = rates.import[category];
                const exportRate = rates.export[category];
                const content = getRowContent(category, theme);

                if (importRate.minRate || exportRate.minRate) {
                  return (
                    <TariffRateTableRow
                      key={category}
                      category={category}
                      importRate={importRate}
                      exportRate={exportRate}
                      content={content}
                      columns={columns}
                    />
                  );
                }

                return null;
              })}
          </tbody>
        </StyledTable>
      </WrapperComponent>
    </>
  );
};

export default TariffRateTableSection;
